module.exports = "/_next/static/images/8e599841629a25e259e2ff12b1da2cfc-man-with-cellphone-md@2x.jpg";